import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import App from './App.vue';
import router from './router';
import { i18n } from './plugins/i18n';
import { firebase } from './plugins/firebase';
import { vMaska } from 'maska/vue';
import { getAnalytics } from 'firebase/analytics';
import { recaptcha } from './plugins/recaptcha';
import VueApexCharts from 'vue3-apexcharts';
import ApexCharts from 'apexcharts';

// ECX UI styles
import '@ecx/ui/styles';

const app = createApp(App);
const pinia = createPinia();
getAnalytics(firebase);

pinia.use(piniaPluginPersistedstate);

app.use(pinia);
app.use(router);
app.use(i18n);
app.use(recaptcha);
app.use(VueApexCharts);
app.directive('maska', vMaska);

/**
 * Verifica se há parâmetros de autenticação externa na URL
 * Se houver, redireciona para /auth-callback que processa tudo com loading
 */
const checkExternalAuthRedirect = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const authFrom = urlParams.get('auth_from');
  
  if (authFrom === 'ecx-auth') {
    // Mantém os parâmetros na URL e redireciona para o callback
    const currentSearch = window.location.search;
    router.replace(`/auth-callback${currentSearch}`);
  }
};

// Após router estar pronto, verifica se precisa redirecionar para callback
router.isReady().then(() => {
  checkExternalAuthRedirect();
});

app.mount('#app');

app.config.globalProperties.$apexcharts = ApexCharts;

declare module 'vue' {
  interface ComponentCustomProperties {
    $apexcharts: typeof ApexCharts;
  }
}
